<template>
  <div class="generalSpreadSelector">
    <v-select
      class="spreadSelector"
      color="#fff"
      item-color="#646464"
      :items="specifiersList"
      dense
      v-model="spreadSelected"
      v-on:change="
        setSpreadToAllEventsOfMarket(tournamentId, marketId, $event, sportId)
      "
    >
    </v-select>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GeneralSpreadSelector',
  props: {
    tournamentId: {},
    marketId: {},
    specifiersList: {},
    calledFrom: {
      type: String,
      default: 'previewPrematch',
    },
    sportId: {},
  },
  data: () => ({
    spreadSelected: null,
  }),
  computed: {
    ...mapGetters({
      getSpreadActivePreviewPrematch:
        'marketview/getSpreadActivePreviewPrematch',
      getSpreadsListPreviewPrematch: 'marketview/getSpreadsListPreviewPrematch',
      getGeneralSpreadActivePreviewPrematch:
        'marketview/getGeneralSpreadActivePreviewPrematch',
      getGeneralSpreadActiveTopMatchPreviewPrematch:
        'marketview/getGeneralSpreadActiveTopMatchPreviewPrematch',
      getGeneralSpreadActiveEventsDayPreviewPrematch:
        'marketview/getGeneralSpreadActiveEventsDayPreviewPrematch',
      getGeneralSpreadActivesForNextEvents:
        'marketview/getGeneralSpreadActivesForNextEvents',
    }),
  },
  methods: {
    ...mapActions({}),

    setSpreadToAllEventsOfMarket(
      tournamentId,
      marketId,
      spreadSelected,
      sportId
    ) {
      switch (this.calledFrom) {
        case 'previewPrematch':
          const payload = {
            marketId: marketId,
            tournamentId: tournamentId,
            spreadSelected: spreadSelected,
          }

          const payload_updating_general_spread_selected_preview = {
            mode: 'replaceExisting',
            marketId: marketId,
            tournamentId: tournamentId,
            spreadSelected: spreadSelected,
          }
          this.$store.commit(
            'marketview/UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_TOURNAMENT_FOR_ALL_EVENTS_PREVIEW_PREMATCH',
            payload
          )
          this.$store.commit(
            'marketview/UPDATE_GENERAL_SPREAD_SELECTED_FOR_MARKET_OF_THIS_TOURNAMENT',
            payload_updating_general_spread_selected_preview
          )

          this.spreadSelected = spreadSelected
          break

        case 'bestPlayedPreviewPrematch':
          const payload_updating_general_spread_best_match = {
            marketId: marketId,
            sportId: sportId,
            spreadSelected: spreadSelected,
            mode: 'replaceExisting',
          }

          const payload_updating_spread_for_events_best_match = {
            marketId: marketId,
            sportId: sportId,
            spreadSelected: spreadSelected,
          }

          this.$store.commit(
            'marketview/UPDATE_GENERAL_SPREAD_SELECTED_FOR_BEST_MATCH_FOR_SPORT',
            payload_updating_general_spread_best_match
          )
          this.$store.commit(
            'marketview/UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_SPORT_FOR_ALL_EVENTS_TOP_GAMES_PREVIEW_PREMATCH',
            payload_updating_spread_for_events_best_match
          )

          this.spreadSelected = spreadSelected
          break

        case 'eventsDayPreviewPrematch':
          const payload_updating_general_spread_event_of_day = {
            marketId: marketId,
            sportId: sportId,
            spreadSelected: spreadSelected,
            mode: 'replaceExisting',
          }

          const payload_updating_spread_selected_for_events_of_day = {
            marketId: marketId,
            sportId: sportId,
            spreadSelected: spreadSelected,
          }

          this.$store.commit(
            'marketview/UPDATE_GENERAL_SPREAD_SELECTED_FOR_EVENT_OF_DAY_FOR_SPORT',
            payload_updating_general_spread_event_of_day
          )
          this.$store.commit(
            'marketview/UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_SPORT_FOR_ALL_EVENTS_OF_DAY_PREVIEW_PREMATCH',
            payload_updating_spread_selected_for_events_of_day
          )

          this.spreadSelected = spreadSelected
          break
        case 'nextEventsWidget':
          const payload_updating_general_spread_next_events = {
            marketId: marketId,
            sportId: sportId,
            spreadSelected: spreadSelected,
            mode: 'replaceExisting',
          }

          const payload_updating_spread_for_events_in_next_events = {
            marketId: marketId,
            sportId: sportId,
            spreadSelected: spreadSelected,
          }

          this.$store.commit(
            'marketview/UPDATE_GENERAL_SPREAD_SELECTED_FOR_NEXT_EVENTS',
            payload_updating_general_spread_next_events
          )
          this.$store.commit(
            'marketview/UPDATE_SPREAD_SELECTED_FOR_MARKET_FOR_ALL_EVENTS_NEXT_EVENTS',
            payload_updating_spread_for_events_in_next_events
          )

          this.spreadSelected = spreadSelected
          break
      }
    },
    initializeSelector() {
      const tournamentId = this.tournamentId
      const marketId = this.marketId
      const sportId = this.sportId

      switch (this.calledFrom) {
        case 'previewPrematch':
          const spreadSelectorForThisTournamentAndMarket = _.filter(
            this.getGeneralSpreadActivePreviewPrematch,
            function (spr) {
              return (
                spr.tournamentId == tournamentId && spr.marketId == marketId
              )
            }
          )

          if (spreadSelectorForThisTournamentAndMarket.length > 0) {
            this.spreadSelected =
              spreadSelectorForThisTournamentAndMarket[0].spreadSelected
            // console.log('spread selected for  market id: ' + marketId + ' is: ' + this.spreadSelected);
          } else {
            // const preferSpread = this.specifiersList.find(specifier=>{
            //     return specifier === '2.5'
            // })
            // if(preferSpread != null){
            //     this.spreadSelected = preferSpread;
            //     this.setSpreadToAllEventsOfMarket(tournamentId, marketId, this.spreadSelected, sportId)
            // }else{
            //     this.spreadSelected = this.specifiersList.length > 0 ? this.specifiersList[0] : null
            // }
            //
            // console.log('spread selezionato per il market id: ' + marketId + ' e il seguente: ' + this.spreadSelected);

            this.setPreferredSpread(tournamentId, marketId, sportId)
          }
          break

        case 'bestPlayedPreviewPrematch':
          const spreadActiveForThisSport = _.filter(
            this.getGeneralSpreadActiveTopMatchPreviewPrematch,
            function (spr) {
              return spr.sportId == sportId && spr.marketId == marketId
            }
          )

          if (spreadActiveForThisSport.length > 0) {
            this.spreadSelected = spreadActiveForThisSport[0].spreadSelected
          } else {
            // const preferSpread = this.specifiersList.find(specifier=>{
            //     return specifier === '2.5'
            // })
            // if(preferSpread != null){
            //     this.spreadSelected = preferSpread;
            //     this.setSpreadToAllEventsOfMarket(tournamentId, marketId, this.spreadSelected, sportId)
            // }else{
            //     this.spreadSelected = this.specifiersList.length > 0 ? this.specifiersList[0] : null
            // }
            //
            // console.log('spread selezionato per il market id: ' + marketId + ' e il seguente: ' + this.spreadSelected);

            this.setPreferredSpread(tournamentId, marketId, sportId)
          }
          break

        case 'eventsDayPreviewPrematch':
          const spreadActiveForThisSportOfDay = _.filter(
            this.getGeneralSpreadActiveEventsDayPreviewPrematch,
            function (spr) {
              return spr.sportId == sportId && spr.marketId == marketId
            }
          )

          if (spreadActiveForThisSportOfDay.length > 0) {
            this.spreadSelected =
              spreadActiveForThisSportOfDay[0].spreadSelected
          } else {
            // const preferSpread = this.specifiersList.find(specifier=>{
            //     return specifier === '2.5'
            // })
            // if(preferSpread != null){
            //     this.spreadSelected = preferSpread;
            //     this.setSpreadToAllEventsOfMarket(tournamentId, marketId, this.spreadSelected, sportId)
            // }else{
            //     this.spreadSelected = this.specifiersList.length > 0 ? this.specifiersList[0] : null
            // }
            //
            // console.log('spread selezionato per il market id: ' + marketId + ' e il seguente: ' + this.spreadSelected);

            this.setPreferredSpread(tournamentId, marketId, sportId)
          }
          break

        case 'nextEventsWidget':
          const spreadActiveForThisSportNextEvent = _.filter(
            this.getGeneralSpreadActivesForNextEvents,
            function (spr) {
              return spr.sportId == sportId && spr.marketId == marketId
            }
          )

          if (spreadActiveForThisSportNextEvent.length > 0) {
            this.spreadSelected =
              spreadActiveForThisSportNextEvent[0].spreadSelected
          } else {
            // const preferSpread = this.specifiersList.find(specifier=>{
            //     return specifier === '2.5'
            // })
            // if(preferSpread != null){
            //     this.spreadSelected = preferSpread;
            //     this.setSpreadToAllEventsOfMarket(tournamentId, marketId, this.spreadSelected, sportId)
            // }else{
            //     this.spreadSelected = this.specifiersList.length > 0 ? this.specifiersList[0] : null
            // }
            //
            // console.log('spread selezionato per il market id: ' + marketId + ' e il seguente: ' + this.spreadSelected);
            this.setPreferredSpread(tournamentId, marketId, sportId)
          }
          break
      }
    },
    setPreferredSpread(tournamentId, marketId, sportId) {
      const preferSpread = this.specifiersList.find(specifier => {
        return specifier === '2.5'
      })
      if (preferSpread != null) {
        this.spreadSelected = preferSpread
        this.setSpreadToAllEventsOfMarket(
          tournamentId,
          marketId,
          this.spreadSelected,
          sportId
        )
      }
    },
  },
  watch: {
    getGeneralSpreadActivePreviewPrematch() {
      // console.log('getGeneralSpreadActivePreviewPrematch watch')
      this.initializeSelector()
    },
    getGeneralSpreadActiveEventsDayPreviewPrematch() {
      // console.log('getGeneralSpreadActiveEventsDayPreviewPrematch watch')
      this.initializeSelector()
    },
    getGeneralSpreadActiveTopMatchPreviewPrematch() {
      // console.log('getGeneralSpreadActiveTopMatchPreviewPrematch watch')
      this.initializeSelector()
    },
    getGeneralSpreadActivesForNextEvents() {
      // console.log('getGeneralSpreadActivesForNextEvents watch')
      this.initializeSelector()
    },
  },
  mounted() {
    // console.log('[DEBUG] mounted the component GenerealSpreadSelector')
    this.initializeSelector()
  },
}
</script>

<style scoped></style>
